export const signUpSelector = state => state.signUp;
